import { createContext, useContext } from 'react';
import { TcsoScreen } from '../components/tcso/TcsoScreenManager';

export interface TcsoInputs {
  mpxn: string;
  chfDeviceId: string;
  gpfDeviceId: string;
  address: string;
  journeyId?: string;
}

interface TcsoContextProps {
  tcsoInputs: TcsoInputs;
  setTcsoInputs: (tcsoState: TcsoInputs) => void;
}

export const tcsoInitialState: TcsoInputs = {
  mpxn: '',
  chfDeviceId: '',
  gpfDeviceId: '',
  address: '',
};

export const TcsoContext = createContext<TcsoContextProps>({
  tcsoInputs: tcsoInitialState,
  setTcsoInputs: () => {},
});

export const useTcsoContext = (): TcsoContextProps => {
  const context = useContext(TcsoContext);
  if (!context) {
    throw new Error('useTcsoContext must be used within a TcsoProvider');
  }
  return context;
};

export interface TcsoScreenInputs {
  tcsoScreen: TcsoScreen;
}

interface TcsoScreenContextProps {
  tcsoScreenInputs: TcsoScreenInputs;
  setTcsoScreenInputs: (tcsoScreenState: TcsoScreenInputs) => void;
}

export const TcsoScreenContext = createContext<TcsoScreenContextProps>({
  tcsoScreenInputs: { tcsoScreen: TcsoScreen.TCSO_CHECKLIST_SCREEN },
  setTcsoScreenInputs: () => {},
});

export const useTcsoScreenContext = (): TcsoScreenContextProps => {
  const context = useContext(TcsoScreenContext);
  if (!context) {
    throw new Error('useTcsoScreenContext must be used within a TcsoScreenProvider');
  }
  return context;
};
